import ColourCellEditor from "../components/ColourCellEditor";
import ColourCellRenderer from "../components/ColourCellRenderer";
import CoordsCellEditor from "../components/CoordsCellEditor";
import CoordsCellRenderer from "../components/CoordsCellRenderer";
import DimensionsCellEditor from "../components/DimensionsCellEditor";
import DimensionsCellRenderer from "../components/DimensionsCellRenderer";
import AlertCellEditor from "../components/AlertCellEditor";
import AlertCellRenderer from "../components/AlertCellRenderer";
import TagStatusCellEditor from "../components/TagStatusCellEditor";
import TagStatusCellRenderer from "../components/TagStatusCellRenderer";
import UserCellEditor from "../components/UserCellEditor";
import UserCellRenderer from "../components/UserCellRenderer";
import PasswordCellEditor from "../components/PasswordCellEditor";
import PasswordCellRenderer from "../components/PasswordCellRenderer";
import CategoryCellEditor from "../components/CategoryCellEditor";
import CategoryCellRenderer from "../components/CategoryCellRenderer";
import RoleCellEditor from "../components/RoleCellEditor";
import RoleCellRenderer from "../components/RoleCellRenderer";
import DateCellEditor  from "../components/DateCellEditor";
import DateCellRenderer from "../components/DateCellRenderer";
import EnergyCellRenderer from "../components/EnergyCellRenderer";
import icon_pen from "../img/icon_pen.png";
import icon_trash from "../img/icon_trash.png";
import icon_eye from "../img/icon_eye.png";



import { useNavigate } from 'react-router-dom';


const SHOW_ID = true;


/////////////////////////////////////////////////////////
//
//
//                  ROCKFALL
//
//
//////////////////////////////////////////////////////////





  // Define columnDefs outside
 export const getColumnDefs_rockfall = (startEditing, stopEditing, setRecordToDelete, goToDetail) => [
    { field: "id", headerName: "Id", editable: false, hide: !SHOW_ID, width: 50 },
    { field: "name", headerName: "Nome", editable: true, flex: 1 },
    { field: "description",  width: 280, headerName: "Descrizione", editable: true, flex: 1 },
    { field: "manufacturer", headerName: "Produttore", editable: true },
    { field: "typology", headerName: "Tipologia",  width: 100, editable: true },
    {
      field: "mel_energy",
      headerName: "Energia MEL",
      cellRenderer: EnergyCellRenderer,
      width: 115,
      editable: true
    },
    {
      field: "dimensions",
      headerName: "Dati geometrici",
      editable: true,
      width: 150,
      cellEditor: DimensionsCellEditor,
      cellRenderer: DimensionsCellRenderer,
      valueGetter: (params) => ({
        length: params.data.length,
        height: params.data.height,
      }),
      valueSetter: (params) => {
        params.data.length = params.newValue.length;
        params.data.height = params.newValue.height;
        return true;
      },
    },
    {
      field: "installation_year",
      headerName: "Anno",
      width: 70,
      editable: true
    },
    {
      field: "revision_year",
      headerName: "Anno Rev.",
      width: 95,
      editable: true
    },
    {
      field: "coordinates",
      headerName: "Coordinate NFC",
      editable: true,
      width: 140,
      cellEditor: CoordsCellEditor,
      cellRenderer: CoordsCellRenderer,
      valueGetter: (params) => ({
        latitude: params.data.latitude,
        longitude: params.data.longitude,
      }),
      valueSetter: (params) => {
        params.data.latitude = params.newValue.latitude;
        params.data.longitude = params.newValue.longitude;
        return true;
      },
    },
    {
      field: "color",
      headerName: "Colore",
      width: 75,
      editable: true,
      cellEditor: ColourCellEditor,
      cellRenderer: ColourCellRenderer,
      cellEditorParams: { values: ["red", "green", "yellow"] },
    },
    {
      field: "has_alert",
      headerName: "Alert",
      width: 75,
      editable: true,
      cellEditor: AlertCellEditor,
      cellRenderer: AlertCellRenderer,
      cellEditorParams: { values: ["danger", "no_danger"] },
    }
  ];


 export const newRowTemplate_rockfall =  {
      name: "",
      description: "",
      latitude: 0,
      longitude: 0,
      color: "green",
      has_alert: false,
      validation_document: null,
      validation_document_date: null,
      rockfall_type: "Rockslide",
      mel_energy: 0,
      height: 0,
      length: 0,
      manufacturer: "",
      installation_year: 0,
      notes: "0",
      revision_year: 0,
      transaction: null,
      width: 0,
    }


export const eyeIconCallback_rockfall = (url)=>{
  window.location.href = url;
}












/////////////////////////////////////////////////////////
//
//
//                  TAG
//
//
//////////////////////////////////////////////////////////





  // Define columnDefs outside
 export const getColumnDefs_tag = (startEditing, stopEditing, setRecordToDelete, goToDetail) => [
     { field: "id", headerName: "Id", editable: false, hide: !SHOW_ID, width: 50 },
    { field: "name", headerName: "Name", editable: true, flex: 1 },
    { field: "unique_code", headerName: "UniqueCode", editable: true },
    {
      field: "coordinates",
      headerName: "Coordinate NFC",
      cellEditor:   CoordsCellEditor,
      cellRenderer: CoordsCellRenderer,
      //valueGetter: (params) => ${params.data.latitude} ${params.data.longitude},
      valueGetter: (params) => {
          return {
             "latitude": params.data.latitude,
             "longitude": params.data.longitude
          }
      },
      valueSetter: (params) => {
          params.data.latitude = params.newValue.latitude;
          params.data.longitude = params.newValue.longitude;
          return true;
      },

      editable: true,
    },
    { field: "status",
      headerName: "Stato",
      cellEditor: TagStatusCellEditor,
      cellRenderer: TagStatusCellRenderer,

      editable: true,
      //cellEditor: ColorCellEditor, // Custom editor for the select dropdown
      cellEditorParams: {
          values: ["attivo", "rotto", "sostituito", "non_posizionato"]
      },
      width: "200"
    }
  ];


 export const getNewRowTemplate_tag = (rockfall_id) => {
     return {
      name: "",
      unique_code: "",
      latitude: 0,
      longitude: 0,
      status: "",
      rockfall: rockfall_id,
      transaction: "",
    }}








/////////////////////////////////////////////////////////
//
//
//                  INTERVENTION
//
//
//////////////////////////////////////////////////////////



  // Define columnDefs outside
 export const getColumnDefs_intervention = (startEditing, stopEditing, setRecordToDelete, goToDetail, users) => [
     { field: "id", headerName: "Id", editable: false, hide: !SHOW_ID, width: 50 },

    { field: "name", headerName: "Name", editable: true, flex: 1 },
    { field: "date",
      headerName: "Data",
      editable: true,
      cellDataType: 'date',
      width: 150,
      cellRenderer: DateCellRenderer,
      cellEditor: DateCellEditor
    },
    { field: "next_revision_date",
      headerName: "Prossima Revisione",
      editable: true,
      cellDataType: 'date',
      width: 180,
      cellRenderer: DateCellRenderer,
      cellEditor: DateCellEditor,
    },
    { field: "description", headerName: "Descrizione", editable: true, cellDataType: 'string',},
    {
      field: "category",
      headerName: "Category",
      width: 150,
      editable: true,
      cellEditor: CategoryCellEditor,
      cellRenderer: CategoryCellRenderer,
      cellEditorParams: { values: ["inspection", "maintenance", "restoration"] },
    },
    { field: "user",
      headerName: "Utente",
      cellEditor: UserCellEditor,
      cellRenderer: UserCellRenderer,
      cellDataType: 'number', // or 'string' depending on what you expect

      editable: true,
      //cellEditor: ColorCellEditor, // Custom editor for the select dropdown
      cellEditorParams: {
          users: users
      },
      valueSetter: (params) => {
        // This is important if you need to update the backend with the selected user ID
        const selectedUserId = params.newValue;
        params.data.user = selectedUserId;  // Update the row data with the selected user ID
        return true;  // Return true to confirm the value change
      },
      width: "180"
    },
  ];


 export const getNewRowTemplate_intervention = (rockfall_id) => {
     return {
      name: "",
      date: "",
      description: "",
      user: 0,
      next_revision_date: "",
      rockfall: rockfall_id,
      transaction: "",
    }}













/////////////////////////////////////////////////////////
//
//
//                  DOCUMENT
//
//
//////////////////////////////////////////////////////////



export const getColumnDefs_document = () => {
    return [
      { field: "name", headerName: "Nome", editable: true, flex: 1 }
    ]
  };



 export const getNewRowTemplate_document = (rockfall_id) => {
     return {
      name: "",
    }}









export const getColumnDefs_installationdocument = (startEditing, stopEditing, setRecordToDelete, goToDetail, users) => {
    return [
      { field: "name", headerName: "Nome", editable: true, flex: 1 },
        { field: "document_date",
          headerName: "Data Inserimentoe",
          editable: true,
          cellDataType: 'date',
          cellRenderer: DateCellRenderer,
          cellEditor: DateCellEditor
        },
        { field: "revision_date",
          headerName: "Data Scadenza Revisione",
          editable: true,
          cellDataType: 'date',
          cellRenderer: DateCellRenderer,
          cellEditor: DateCellEditor
        },
        { field: "user",
          headerName: "Utente",
          cellEditor: UserCellEditor,
          cellRenderer: UserCellRenderer,
          cellDataType: 'number', // or 'string' depending on what you expect

          editable: true,
          //cellEditor: ColorCellEditor, // Custom editor for the select dropdown
          cellEditorParams: {
              users: users
          },
          valueSetter: (params) => {
            // This is important if you need to update the backend with the selected user ID
            const selectedUserId = params.newValue;
            params.data.user = selectedUserId;  // Update the row data with the selected user ID
            return true;  // Return true to confirm the value change
          },
          width: "180"
        },
        ]
  };



 export const getNewRowTemplate_installationdocument = (rockfall_id) => {
     return {
      name: "",
      document_date: "",
      revision_date: "",
      user: ""
    }}





/////////////////////////////////////////////////////////
//
//
//                  USERS
//
//
//////////////////////////////////////////////////////////



export const getColumnDefs_user = () => {
    return [
        { field: "id", headerName: "Id", editable: false, hide: !SHOW_ID, width: 50 },

      { field: "first_name", headerName: "Nome", editable: true, flex: 1  },
      { field: "last_name", headerName: "Cognome", editable: true, flex: 1  },
      { field: "email", headerName: "Email", editable: true },
      { field: "password",
        headerName: "Password",
        editable: true,
        cellEditor: PasswordCellEditor,
        cellRenderer: PasswordCellRenderer,
        valueGetter: (params) => ({
          password: params.data.password,
          password_confirmation: params.data.password_confirmation,
        }),
        valueSetter: (params) => {
          params.data.password = params.newValue.password;
          params.data.password_confirmation = params.newValue.password_confirmation;
          return true;
        },
      },
      { field: "device_code", headerName: "Codice Device", editable: true },
      {
        field: "role",
        headerName: "Ruolo",
        width: 170,
        editable: true,
        cellEditor: RoleCellEditor,
        cellRenderer: RoleCellRenderer,
        cellEditorParams: { values: ["Base", "Intermediate", "Advanced", "Admin"] },
      },
    ]
  };



 export const getNewRowTemplate_user = (rockfall_id) => {
     return {
      first_name: "",
      last_name: "",
      email: "",
      device_code: "",
      role: "",
    }}



